import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'mlp-ng-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LoadingSharedComponent {}
